import script from "./TransactionConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionConfirm.vue?vue&type=script&setup=true&lang=js"

import "./TransactionConfirm.vue?vue&type=style&index=0&id=1b25f8fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b25f8fa"]])

export default __exports__